/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/

const urlRegex =
  /^(?:([A-Za-z]+):)?(\/{0,3})([0-9._\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/

export const safeGet = (Object, path) =>
  path
    .replace(/\[([^\[\]]*)\]/g, '.$1.')
    .split('.')
    .filter(t => t !== '')
    .reduce((prev, cur) => prev && prev[cur], Object)

export const getHosts = url => {
  let reg_res = urlRegex.exec(url)
  return {
    protocol: reg_res[1],
    host: reg_res[3],
    port: reg_res[4] || (reg_res[1] === 'http' ? 80 : 443),
    path: reg_res[5],
  }
}

/**
 * 字符串首位转换成大写
 * @param value {object} 目标值
 * */
export const firstToUpper = str => {
  return str.replace(/\b(\w)(\w*)/g, ($0, $1, $2) => {
    return $1.toUpperCase() + $2.toLowerCase()
  })
}

/**
 * 字符串分割合并转换成驼峰式 例子: aa_bb => aaBb
 * @param value {object} 目标值
 * */
export const transformFormatKey = (key, flag) => {
  return key.split(flag).reduce((acc, cur) => {
    return acc + firstToUpper(cur)
  })
}
/**
 * 对象key转换成驼峰格式
 * @param value {object} 目标值
 * */
export const transformFormat = (targetValue, flag = '_') => {
  const isObject =
    typeof targetValue === 'object' && !(targetValue instanceof Array)
  // const isString = typeof targetValue === 'String'
  const result = {}
  if (!isObject) return new Error('targetValue is not an object')

  Object.keys(targetValue).forEach(item => {
    const key = transformFormatKey(item, flag)
    result[key] = targetValue[item]
  })

  return result
}

/**
 * 扁平化数据
 * @param data {array} 目标值
 * @return {object}
 * */
export const transformFlattenData = (data = []) => {
  let result = {}
  data.forEach(item => {
    if (item.value) {
      try {
        result[item.key] = JSON.parse(item.value)
      } catch (e) {
        result[item.key] = item.value
      }
    }
  })

  return transformFormat(result)
}

// 删除base64的等号，服务端接口上报存在此类情况需要
export const removeBase64Padding = base64Str => {
  const paddingCount = (base64Str.match(/=*$/)[0] || '').length
  return !paddingCount ? base64Str : base64Str.slice(0, -paddingCount)
}
